import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "fill-height bg_auth" }
const _hoisted_2 = { class: "d-flex justify-center mb-4" }
const _hoisted_3 = ["height", "width"]
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = {
  key: 0,
  class: "text--secondary"
}
const _hoisted_6 = { class: "d-flex justify-space-between my-4" }
const _hoisted_7 = { class: "d-flex justify-end my-4" }
const _hoisted_8 = { class: "d-flex justify-center mb-4" }
const _hoisted_9 = ["src", "height", "width"]
const _hoisted_10 = { class: "d-flex justify-end mt-4" }
const _hoisted_11 = { class: "d-flex justify-center mb-4" }
const _hoisted_12 = { class: "d-flex justify-end mt-4" }
const _hoisted_13 = { class: "d-flex justify-center mb-4" }
const _hoisted_14 = ["height", "width"]
const _hoisted_15 = { class: "d-flex justify-end mt-4" }
const _hoisted_16 = { class: "d-flex justify-center mb-4" }
const _hoisted_17 = ["height", "width"]
const _hoisted_18 = { class: "d-flex justify-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_window, {
      modelValue: _ctx.authStep,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.authStep) = $event)),
      class: "elevation-1 fill-height"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, {
          value: "login",
          id: "#login",
          class: "fill-height"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "d-flex align-center justify-center fill-height",
              style: {"height":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "10",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("img", {
                          src: "/img/bobbee_logo_3.png",
                          height: !_ctx.$vuetify.display.mobile ? '100vh' : '',
                          width: !_ctx.$vuetify.display.mobile ? '' : '200vw'
                        }, null, 8, _hoisted_3)
                      ]),
                      _createVNode(_component_v_form, {
                        modelValue: _ctx.valid,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.valid) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_text_field, {
                              label: "E-mail",
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                              onKeyup: _withKeys(_ctx.login, ["enter"]),
                              error: _ctx.error.length > 0,
                              "data-cy": "login-email",
                              id: "login-email",
                              rules: [_ctx.rules.notEmpty, _ctx.rules.isEmail]
                            }, null, 8, ["modelValue", "onKeyup", "error", "rules"])
                          ]),
                          (_openBlock(), _createElementBlock("div", {
                            key: _ctx.SSOProviderRequestOnGoing + 1,
                            style: {"min-height":"62px"},
                            class: "d-flex align-center justify-center"
                          }, [
                            (_ctx.SSOEnabled)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createVNode(_component_v_icon, {
                                    left: "",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                                      _createTextVNode(" $fa-lock ")
                                    ])),
                                    _: 1
                                  }),
                                  _cache[26] || (_cache[26] = _createTextVNode(" Connexion SAML SSO "))
                                ]))
                              : (_openBlock(), _createBlock(_component_v_text_field, {
                                  modelValue: _ctx.password,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                                  label: "Mot de passe",
                                  type: _ctx.displayPassword ? 'text' : 'password',
                                  onKeyup: _withKeys(_ctx.login, ["enter"]),
                                  "append-inner-icon": 
                                            _ctx.displayPassword ? '$oss-eye' : '$oss-eye-slash'
                                        ,
                                  "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayPassword = !_ctx.displayPassword)),
                                  error: _ctx.error.length > 0,
                                  "error-messages": _ctx.error,
                                  "data-cy": "login-password",
                                  id: "login-password",
                                  rules: [_ctx.rules.notEmpty],
                                  key: _ctx.SSOProviderRequestOnGoing
                                }, null, 8, ["modelValue", "type", "onKeyup", "append-inner-icon", "error", "error-messages", "rules"]))
                          ]))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_btn, {
                        class: "elevation-0 rounded-lg mt-2",
                        block: "",
                        loading: _ctx.loading,
                        onClick: _ctx.login,
                        "data-cy": "login-login",
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.SSOEnabled ? "Continuer" : "Se connecter"), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_btn, {
                          "align-left": "",
                          href: "mailto:support@bobbee.co",
                          color: "secondary",
                          variant: "text"
                        }, {
                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                            _createTextVNode(" Nous contacter ")
                          ])),
                          _: 1
                        }),
                        (_ctx.ENABLE_COGNITO)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.authStep = 'forgotPassword')),
                              color: "secondary",
                              variant: "text"
                            }, {
                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                _createTextVNode(" Mot de passe oublié ? ")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_v_divider, { inset: "" }),
                      _createElementVNode("div", _hoisted_7, [
                        (_ctx.DEV_MODE)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.register())),
                              color: "secondary",
                              variant: "text",
                              class: "block"
                            }, {
                              default: _withCtx(() => _cache[29] || (_cache[29] = [
                                _createTextVNode(" Créez un nouveau compte ? ")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "resendSignupEmail" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: _ctx.valid,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.valid) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  class: "d-flex align-center justify-center",
                  style: {"height":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("img", {
                              src: _ctx.bobbeeLogo,
                              height: !_ctx.$vuetify.display.mobile ? '12vh' : '',
                              width: !_ctx.$vuetify.display.mobile ? '' : '22vw'
                            }, null, 8, _hoisted_9)
                          ]),
                          _createVNode(_component_v_text_field, {
                            label: "E-mail",
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email) = $event)),
                            onKeyup: _withKeys(_ctx.resendSignupEmail, ["enter"]),
                            "data-cy": "login-forgotPassword-email",
                            "hide-details": "auto",
                            outlined: "",
                            class: "mb-4",
                            density: "compact"
                          }, null, 8, ["modelValue", "onKeyup"]),
                          _createVNode(_component_v_btn, {
                            class: "elevation-0 rounded-lg",
                            block: "",
                            loading: _ctx.loading,
                            onClick: _ctx.resendSignupEmail,
                            "data-cy": "resendSignupEmail",
                            size: "large"
                          }, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode(" Renvoyer un email de réinitialisation de mot de passe ")
                            ])),
                            _: 1
                          }, 8, ["loading", "onClick"]),
                          _createVNode(_component_v_alert, {
                            modelValue: _ctx.alertResendSignupEmail,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.alertResendSignupEmail) = $event)),
                            type: _ctx.alertResendSignupEmailType,
                            class: "mt-4",
                            outlined: "",
                            density: "compact"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.alertResendSignupEmailMessage), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "type"]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.authStep = 'login')),
                              color: "secondary",
                              variant: "text"
                            }, {
                              default: _withCtx(() => _cache[31] || (_cache[31] = [
                                _createTextVNode(" Revenir à la page de connexion")
                              ])),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          value: "forgotPassword",
          id: "#forgotPassword",
          class: "fill-height"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: _ctx.valid,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.valid) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  class: "d-flex align-center justify-center",
                  style: {"height":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_v_img, {
                              src: "/img/bobbee_logo_3.png",
                              height: !_ctx.$vuetify.display.mobile ? '12vh' : '',
                              width: !_ctx.$vuetify.display.mobile ? '' : '22vw'
                            }, null, 8, ["height", "width"])
                          ]),
                          _cache[34] || (_cache[34] = _createElementVNode("p", null, "Entrez l'adresse e-mail du compte", -1)),
                          _createVNode(_component_v_text_field, {
                            label: "E-mail",
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.email) = $event)),
                            onKeyup: _withKeys(_ctx.sendForgotPasswordEmail, ["enter"]),
                            error: _ctx.forgotPasswordError.length > 0,
                            "data-cy": "login-forgotPassword-email",
                            "hide-details": "auto",
                            outlined: "",
                            class: "mb-4 mt-4",
                            density: "compact"
                          }, null, 8, ["modelValue", "onKeyup", "error"]),
                          _createVNode(_component_v_btn, {
                            class: "elevation-0 rounded-lg",
                            block: "",
                            loading: _ctx.loading,
                            onClick: _ctx.sendForgotPasswordEmail,
                            "data-cy": "sendEmailForgotPassword",
                            size: "large"
                          }, {
                            default: _withCtx(() => _cache[32] || (_cache[32] = [
                              _createTextVNode(" Envoyer un code de réinitialisation ")
                            ])),
                            _: 1
                          }, 8, ["loading", "onClick"]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.authStep = 'login')),
                              color: "secondary",
                              variant: "text"
                            }, {
                              default: _withCtx(() => _cache[33] || (_cache[33] = [
                                _createTextVNode(" Revenir à la page de connexion ")
                              ])),
                              _: 1
                            })
                          ]),
                          _createVNode(_component_v_divider, { class: "mt-4" }),
                          _createVNode(_component_v_alert, {
                            modelValue: _ctx.alertForgotPassword,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.alertForgotPassword) = $event)),
                            type: "warning",
                            class: "mt-4",
                            outlined: "",
                            density: "compact"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.forgotPasswordError), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_v_alert, {
                            modelValue: _ctx.alertResendSignupEmail,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.alertResendSignupEmail) = $event)),
                            type: _ctx.alertResendSignupEmailType,
                            class: "mt-4",
                            outlined: "",
                            dense: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.alertResendSignupEmailMessage), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "type"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          value: "verificationCode",
          id: "#verificationCode",
          class: "fill-height"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "d-flex align-center justify-center",
              style: {"height":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("img", {
                          src: "/img/bobbee_logo_3.png",
                          height: !_ctx.$vuetify.display.mobile ? '12vh' : '',
                          width: !_ctx.$vuetify.display.mobile ? '' : '22vw'
                        }, null, 8, _hoisted_14)
                      ]),
                      _createElementVNode("p", null, "Nous venons d'envoyer un code de vérification à " + _toDisplayString(_ctx.email), 1),
                      _createVNode(_component_v_otp_input, {
                        modelValue: _ctx.otp,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.otp) = $event)),
                        length: "6",
                        type: "number",
                        class: "mb-4 oss-otp-flat"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_btn, {
                        class: "elevation-0 rounded-lg",
                        block: "",
                        loading: _ctx.loading,
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.authStep = 'changePassword')),
                        "data-cy": "sendEmailForgotPassword",
                        size: "large"
                      }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createTextVNode(" Suivant ")
                        ])),
                        _: 1
                      }, 8, ["loading"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.authStep = 'forgotPassword')),
                          color: "secondary",
                          variant: "text"
                        }, {
                          default: _withCtx(() => _cache[36] || (_cache[36] = [
                            _createTextVNode(" Retour")
                          ])),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          value: "changePassword",
          id: "#changePassword",
          class: "fill-height"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "d-flex align-center justify-center",
              style: {"height":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("img", {
                          src: "/img/bobbee_logo_3.png",
                          height: !_ctx.$vuetify.display.mobile ? '12vh' : '',
                          width: !_ctx.$vuetify.display.mobile ? '' : '22vw'
                        }, null, 8, _hoisted_17)
                      ]),
                      _cache[39] || (_cache[39] = _createElementVNode("p", null, "Vous pouvez redéfinir un nouveau mot de passe ci-dessous", -1)),
                      _createVNode(_component_v_text_field, {
                        label: "Nouveau mot de passe",
                        type: _ctx.displayPassword ? 'text' : 'password',
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.password) = $event)),
                        onKeyup: _withKeys(_ctx.login, ["enter"]),
                        "append-inner-icon": _ctx.displayPassword ? '$oss-eye' : '$oss-eye-slash',
                        error: _ctx.error.length > 0,
                        "error-messages": _ctx.error,
                        "hide-details": "auto",
                        "data-cy": "login-change-password",
                        class: "mb-4 mt-4",
                        outlined: "",
                        density: "compact",
                        "onClick:appendInner": _cache[19] || (_cache[19] = ($event: any) => (_ctx.displayPassword = !_ctx.displayPassword))
                      }, null, 8, ["type", "modelValue", "onKeyup", "append-inner-icon", "error", "error-messages"]),
                      _createVNode(_component_v_text_field, {
                        label: "Confirmez votre nouveau mot de passe",
                        type: _ctx.displayPassword ? 'text' : 'password',
                        modelValue: _ctx.confirmPassword,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                        onKeyup: _withKeys(_ctx.login, ["enter"]),
                        "append-inner-icon": _ctx.displayPassword ? '$oss-eye' : '$oss-eye-slash',
                        error: _ctx.error.length > 0,
                        "error-messages": _ctx.error,
                        "hide-details": "auto",
                        "data-cy": "login-change-password-confirm",
                        class: "mb-4",
                        outlined: "",
                        density: "compact",
                        "onClick:appendInner": _cache[21] || (_cache[21] = ($event: any) => (_ctx.displayPassword = !_ctx.displayPassword))
                      }, null, 8, ["type", "modelValue", "onKeyup", "append-inner-icon", "error", "error-messages"]),
                      _createVNode(_component_v_btn, {
                        class: "elevation-0 rounded-lg",
                        block: "",
                        loading: _ctx.loading,
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.confirmForgotPassword())),
                        "data-cy": "sendEmailForgotPassword",
                        size: "large"
                      }, {
                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                          _createTextVNode(" Changer le mot de passe ")
                        ])),
                        _: 1
                      }, 8, ["loading"]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.authStep = 'login')),
                          color: "secondary",
                          variant: "text"
                        }, {
                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                            _createTextVNode(" Revenir à la page de connexion")
                          ])),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}